<template>
  <b-modal id="ts_send_create_worker_modal" ref="ts_send_create_worker_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1><i class="fas fa-street-view"></i> Create Worker to Site</h1>
      </div>
      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <div class="row">
      <div class="col-12">
        Send data to create a worker to the following company:<br>
        <strong>{{ company_name }}</strong>
        <hr>
      </div>
      <div class="col-12">
        <ValidationObserver ref="sendCreateWorkerForm" slim>
          <form role="form" @submit.prevent="submit_send_create_worker" class="row" autocomplete="off">

          <!-- First Name -->
          <ValidationProvider rules="required" v-slot="{ errors, classes }" name="First Name" tag="div" class="col-12 form-group">
            <label class="form-label" for="first_name">First Name</label>
            <input type="text" id="first_name" v-model="first_name" :class="classes" class="form-control">
            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
          </ValidationProvider>
          
          <!-- Surname -->
          <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Surname" tag="div" class="col-12 form-group">
            <label class="form-label" for="surname">Surname</label>
            <input type="text" id="surname" v-model="surname" :class="classes" class="form-control">
            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
          </ValidationProvider>
    

            <!-- Amount -->
            <ValidationProvider rules="required|decimal" v-slot="{ errors, classes }" name="Amount" tag="div" class="col-12 form-group">
              <label class="form-label" for="amount">Amount</label>
              <input type="decimal" id="amount" v-model="amount" :class="classes" class="form-control">
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            
            <!-- Description -->
            <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Description" tag="div" class="col-12 form-group">
              <label class="form-label" for="description">Description</label>
              <textarea id="description" v-model="description" :class="classes" class="form-control"></textarea>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>



            <div v-if="check_all_form_details" class="col-6 offset-6">
              <button type="submit" class="btn orcaBtn" :disabled="saving">
                <span v-if="!saving">Send to create Worker</span>
                <span v-else-if="saving"><i class="fas fa-spinner fa-spin"></i> Sending to create the Worker...</span>
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "ts_send_create_worker",
  props: [
    'company_name', 
        ],
  components: {Multiselect},
  data() {
    return {
      default_pension: process.env.MIX_PENSION_STANDARD_PERC,
      default_ni: process.env.MIX_NI,
      default_holiday_accrual: process.env.MIX_HOLIDAY_ACCRUAL,

      company_id: this.$store.state.client_timesheets.ts_send_create_worker.company_id,
      current_for_work_end_week_date: this.$store.state.client_timesheets.ts_send_create_worker.for_work_end_week_date,

      first_name: null,
      surname: null,
      amount: null,
      description: null,

      saving: false
    }
  },
  beforeMount() {
  },
  computed: {
    check_all_form_details() {
      if (this.first_name && this.surname && this.amount && this.description) {
          return true
      }
      else {
        return false;
      }
    },
  },
  methods: {
    hideModal() {
      this.$refs.ts_send_create_worker_modal.hide();
      this.$store.commit('HIDE_SEND_CREATE_WORKER_MODAL');
    },

    /***********************************************************************
     *  Submit
     ***********************************************************************/

    submit_send_create_worker() {
      this.saving = true;
      let temp_send = {
        company_id: this.company_id,
        company_name: this.company_name,
        current_for_work_end_week_date: this.current_for_work_end_week_date,
        first_name: this.first_name,
        surname: this.surname,
        amount: this.amount,
        description: this.description,
        user_name: this.$store.state.auth.me.first_name + ' ' + this.$store.state.auth.me.surname,
      }
      
      // console.log(temp_send);
      // console.log(this.$store.state.auth.me);
      // console.log(this.$store.state.client_timesheets);
      // send email
      axios.post(this.crmApiPath + 'worker/email/send_email_to_create_worker', temp_send).then(() => {
        // hide the modal
        this.hideModal();

      });


    }
  },
}
</script>

<style lang="scss">
#ts_send_create_worker_modal {
  .multiselect__option {
    &:hover, &:focus, &:active, &:active:focus, &.active:focus,
    &.focus, &:active.focus, &.active.focus {
      background: $bc_1;
      color:      $white;
    }
  }

  .noResult {
    margin:      -10px -30px -10px -15px;
    padding:     10px 15px;
    height:      38px;
    line-height: inherit;
    display:     block;
    width:       100%;

    &:hover, &:focus, &:active, &:active:focus, &.active:focus,
    &.focus, &:active.focus, &.active.focus {
      color:      $white;
      background: $bc_1;
    }
  }
}
</style>
